import { action, deprecated } from 'typesafe-actions';
import * as H from 'history';

const { createStandardAction } = deprecated;

export const redirect = (arg: string) => action('router/REDIRECT', arg);
export const init = (arg: H.History) => action('router/INIT', arg);

export const setReturnUrl = createStandardAction('router/SET_RETURN_URL')<string>();